import { SessionStorageUtils } from '@brunommsilva/react-foundations';

import { TransactionsFilter } from './filter';

class TransactionsFilterStorage {
  private readonly KEY = 'transactions_filter';

  public get(): TransactionsFilter {
    const saved = SessionStorageUtils.getItem<TransactionsFilter>(this.KEY);
    return saved ? new TransactionsFilter(saved) : new TransactionsFilter();
  }

  public set(filter: TransactionsFilter): void {
    SessionStorageUtils.setItem(this.KEY, filter);
  }

  public clear(): void {
    SessionStorageUtils.removeItem(this.KEY);
  }
}

const transactionsFilterStorage = new TransactionsFilterStorage();
export default transactionsFilterStorage;
